import { Component, input, output } from '@angular/core'

import type { stringMap } from '../../types'

@Component({
  selector: 'dhp-filter-strings-checkbox',
  templateUrl: './filter-strings-check-box.html',
})
export class FilterStringsCheckBox {
  currentString = input.required<stringMap>()
  isSelected = input.required<boolean>()

  selected = output<stringMap>()
}
